<div class="d-flex flex-row types__buisness justify-content-between">
  <div>{{title | translate}} *</div>
  <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
    <div class="d-flex flex-row alert-danger-content">
      <div class="alert-danger-info" matTooltipClass="tooltip-danger"
        matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
        <div>?</div>
      </div>
    </div>
  </div>
</div>
<p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [options]="list" (onChange)="shareCheckedlist()" [(ngModel)]="checkedList" [required]="true"
  defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="name" optionValue="id"
  [maxSelectedLabels]="list.length" display="chip" selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}"
  #item="ngModel">
  <ng-template pTemplate="header">
    <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
  </ng-template>
</p-multiSelect>